export default {
  Required: 'Required',
  'Required at least 1': 'Required at least 1',
  'Impossible number': 'Impossible number',
  'Invalid number': 'Invalid number',
  'Invalid email': 'Invalid email',
  'Must contain digits only': 'Must contain digits only',
  'Must be a string': 'Must be a string',
  'Person must be older 18 years old': 'Person must be older 18 years old',
  'Must be issued at least {{days}} days ago': 'Must be issued at least {{days}} days ago',
  'Must be valid for at least {{days}} days': 'Must be valid for at least {{days}} days',
  'Must be like https://example.com': 'Must be like https://example.com',
  'Must be at least {{count}} character': 'Must be at least {{count}} character',
  'Must be at least {{count}} characters': 'Must be at least {{count}} characters',
  'Max length is {{count}} character': 'Max length is {{count}} character',
  'Max length is {{count}} characters': 'Max length is {{count}} characters',
  'Must be {{count}} character': 'Must be {{count}} character',
  'Must be {{count}} characters': 'Must be {{count}} characters',
  'Min is {{minNumber}}': 'Min is {{minNumber}}',
  'Max is {{maxNumber}}': 'Max is {{maxNumber}}',
  'Must be more than {{num}}': 'Must be more than {{num}}',
  'Must be less than {{num}}': 'Must be less than {{num}}',
  'Total shares is {{totalShares}}': 'Total shares is {{totalShares}}',
  'Incorrect IBAN format': 'Incorrect IBAN format',
  'English letters and spaces only': 'English letters and spaces only',
  'IBAN must be SA followed by 22 digits': 'IBAN must be SA followed by 22 digits',
  'IBAN invalid length': 'IBAN must be exactly 24 characters',
  'IBAN must start with SA': 'IBAN must start with "SA"',
  'IBAN check digits invalid': 'IBAN check digits (characters 3–4) must be numeric',
  'IBAN body must be alphanumeric': 'IBAN bank/account number (characters 5–24) must be alphanumeric',
  'IBAN checksum invalid': 'IBAN checksum is invalid — please verify and re-enter',
  'Enter a valid 8 or 11 character Swift Code': 'Enter a valid 8 or 11 character Swift Code',
  'Must starts with {{countryCode}}': 'Must starts with {{countryCode}}',
  'Impossible Emirates ID. Check for typos carefully':
    'Impossible Emirates ID. Check for typos carefully',
  "Character '.' (dot) should not be first or last character":
    "Character '.' (dot) should not be first or last character",
  "Character ' ' (space) should not be first or last character":
    "Character ' ' (space) should not be first or last character",
  "Character '.' (dot) should not appear two or more times consecutively":
    "Character '.' (dot) should not appear two or more times consecutively",
  "Character ' ' (space) should not appear two or more times consecutively":
    "Character ' ' (space) should not appear two or more times consecutively",
  'Includes forbidden symbols': 'Includes forbidden symbols',
  'Max length is 255 characters': 'Max length is 255 characters',
  "Character ' ' (space) is forbidden": "Character ' ' (space) is forbidden",
  'Should contain only letters (A-Z) and digits (0-9)':
    'Should contain only letters (A-Z) and digits (0-9)',
  'A-Z (hyphen) and 0-9 symbols are allowed only': 'A-Z (hyphen) and 0-9 symbols are allowed only',
  'Must be unique. Check another representative': 'Must be unique. Check another representative',
  'Must be unique. Check another shareholder': 'Must be unique. Check another shareholder',
  'Mark at least one person as an authorized signatory':
    'Mark at least one person as an authorized signatory',
  'Upload Copy of Memorandum of Association or Partnership deed':
    'Upload Copy of Memorandum of Association or Partnership deed',
  'Total shares must be at least {{minShares}}%': 'Total shares must be at least {{minShares}}%',
  'Edit persons at corresponding pages': 'Edit persons at corresponding pages',
  'Must includes letters': 'Must includes letters',
  'Must includes only letters': 'Must includes only letters',
  'Must include only latin letters': 'Must include only latin letters',
  'Please provide authorised signatory proof and email for individual shareholder to proceed.':
    'Please provide authorised signatory proof and email for individual shareholder to proceed.',
  'Please provide Beneficial owners details to proceed.':
    'Please provide Beneficial owners details to proceed.',
  'Only KSA banks are allowed': 'Only KSA banks are allowed',
  'Please provide missing passport details for all persons who have a passport number':
    'Please provide missing passport details for all persons who have a passport number',
  'License is expired': 'License is expired',
  'Some mandatory data is empty. Please add the business address manually':
    'Some mandatory data is empty. Please add the business address manually',
  'Latest automated screening result has an Error. Please add the screening resolution manually':
    'Latest automated screening result has an Error. Please add the screening resolution manually',
  "A tax registration certificate is required based on your company's turnover value. Kindly complete the necessary data to proceed.":
    "A tax registration certificate is required based on your company's turnover value. Kindly complete the necessary data to proceed.",
};
